export * from './projekt-arts-list.component';
export * from './projekt-arts-list.component.module';